exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "th[data-v-0462f477],td[data-v-0462f477]{vertical-align:middle}", "", {"version":3,"sources":["/home/circleci/repo/app/components/commons/orders/Table.vue"],"names":[],"mappings":"AAwHA,wCACE,qBAAA,CAAA","file":"Table.vue?vue&type=style&index=0&id=0462f477&scoped=true&lang=sass&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nth, td\n  vertical-align: middle\n"],"sourceRoot":""}]);

// exports
